import React from 'react';

import './loading.css'
export default function components({msg}) {
  return (
    <div>

      <div class="text-loading">{msg}</div>
      <div class="loading"></div>
    </div>
  )
}
